export default __webpack_public_path__ + "static/media/banner.0764fbcb.jpeg";